import { useParams, Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import EnvolvementThumbnail from "../appComponents/explorePage/EnvolvementThumbnail";

const BACKEND_DOMAIN =
  process.env.REACT_APP_BACKEND_DOMAIN ?? "ENV BACKEND_DOMAIN DEFAULT";
const BACKEND_PORT =
  process.env.REACT_APP_BACKEND_PORT ?? "ENV BACKEND_PORT DEFAULT";

const ProfileHeader = ({ userProfile }) => {
  const [bannerUrl, setBannerUrl] = useState(null);

  useEffect(() => {
    if (
      userProfile &&
      userProfile.user_metadata &&
      userProfile.user_metadata.banner_url
    ) {
      setBannerUrl(userProfile.user_metadata.banner_url);
    }
  }, [userProfile]);

  return (
    <div className="relative w-full h-60 bg-gray-200 dark:bg-gray-700 group rounded-lg">
      {bannerUrl ? (
        <img
          src={bannerUrl}
          alt="Profile banner"
          className="w-full h-full object-cover rounded-lg"
        />
      ) : (
        <div className="w-full h-full bg-gray-100 rounded-lg" />
      )}
    </div>
  );
};

function ProfileID() {
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [envolvements, setEnvolvements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(
          `${BACKEND_DOMAIN}${BACKEND_PORT}/user_profile_info/${id}`
        );
        const userData = await res.json();
        setProfile(userData);

        // Use the full user_id from the profile response to fetch envolvements
        if (userData.user_id) {
          const envolvementRes = await fetch(
            `${BACKEND_DOMAIN}${BACKEND_PORT}/profile/${userData.user_id}`
          );
          const envolvementData = await envolvementRes.json();
          setEnvolvements(envolvementData);
        } else {
          setEnvolvements([]);
        }
      } catch (e) {
        setProfile(null);
        setEnvolvements([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [id]);

  return (
    <div className="max-w-4xl mx-auto w-full px-2 sm:px-4 md:px-8">
      <ProfileHeader userProfile={profile} />
      <div className="relative flex flex-col items-center -mt-16 mb-6">
        {profile?.picture && (
          <img
            className="border-double border-black border-8 rounded-full w-32 h-32 object-cover bg-white"
            src={profile.picture}
            alt={profile?.name}
          />
        )}
        <div className="mt-4 flex flex-col items-center gap-2">
          <h1 className="text-2xl font-bold text-center">
            {profile?.nickname || profile?.name}
          </h1>
          {profile?.email && (
            <p className="text-gray-500 text-center">{profile.email}</p>
          )}
        </div>
      </div>
      {/* Envolvements Section */}
      <div className="mb-8">
        <h2 className="text-xl font-bold mb-4 text-center">Envolvements</h2>
        {loading ? (
          <div className="flex justify-center items-center min-h-[200px]">
            Loading...
          </div>
        ) : envolvements.length === 0 ? (
          <div className="flex flex-col items-center justify-center min-h-[200px]">
            <p className="text-lg text-gray-600 mb-4 text-center">
              This user has no Envolvements.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {envolvements.map((envolvement) => (
              <Link
                key={envolvement._id}
                to={`/envolvement/${envolvement._id}`}
                className="block h-full"
              >
                <EnvolvementThumbnail data={envolvement} />
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ProfileID;
